var _circle, _path, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4062,
    cy: 15,
    r: 14.5,
    fill: "#EEE6FF",
    stroke: "url(#paint0_linear_1151_4367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4111 8C11.8589 8 11.4111 8.44772 11.4111 9V10H7.41115C6.85886 10 6.41115 10.4477 6.41115 11V21C6.41115 21.5523 6.85886 22 7.41115 22H23.4111C23.9634 22 24.4111 21.5523 24.4111 21V11C24.4111 10.4477 23.9634 10 23.4111 10H19.4111V9C19.4111 8.44772 18.9634 8 18.4111 8H12.4111Z",
    fill: "url(#paint1_linear_1151_4367)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4063,
    cy: 15.9744,
    r: 3.50488,
    stroke: "#EEE5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1151_4367",
    x1: -0.427084,
    y1: 1.67638e-7,
    x2: 29.5729,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8084F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1151_4367",
    x1: 5.91115,
    y1: 8,
    x2: 19.4804,
    y2: 25.4462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8084F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48FED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/profile_camera.91a8223040ad923d15a264896c1c7224.svg";
export { ForwardRef as ReactComponent };